<template>
  <div class="exchange">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
.exchange {
  height: calc(100% - 50px);
  padding: 10px;
  margin-top: 10px;
  box-shadow: #eee 0px 0px 10px;
}
</style>
